import template from './setup.edit.html';
import controller from './setup.edit.controller';
import './setup.edit.scss';

let setupeditComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default setupeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/edit/setup.edit.component.js